import { instanceBase as axios } from '../lib/axios';
import { onSelectExercise, onTerminateHomework, onShowExerciseCorrection, onGetHomework, onShowHomeworkCorrection } from './statements';

import {
    START_HOMEWORK,
    SELECT_EXERCISE,
    SHOW_EXERCISE_CORRECTION,
    CORRECT_ALL_EXERCISES,
    SHOW_ALL_EXERCISES_CORRECTIONS,
} from '../actions/status';

import { STATEMENTS_URL } from '../config';

const trackingsMappings = {
    [SELECT_EXERCISE]: [onSelectExercise],
    [SHOW_EXERCISE_CORRECTION]: [onShowExerciseCorrection],
    [CORRECT_ALL_EXERCISES]: [onTerminateHomework],
    [START_HOMEWORK]: [onGetHomework, onSelectExercise],
    [SHOW_ALL_EXERCISES_CORRECTIONS]: [onShowHomeworkCorrection],
};

/**
 * Middleware for intercepting Lockers events.
 */
const lockerMiddleware = (store) => (next) => (action) => {
    const result = next(action);
    const state = store.getState();

    const isTerminationTracked = state?.application?.isTerminationTracked;

    const isGoogle = !!state?.application?.googleCourseWorkId;

    if (!(isGoogle && isTerminationTracked && !action.type === SHOW_ALL_EXERCISES_CORRECTIONS)) {
        const trackings = trackingsMappings[action.type];

        if (trackings) {
            trackings.forEach((tracking) => {
                const payload = tracking(state, action);

                axios.post(STATEMENTS_URL, payload, {
                    params: state.application.platform ? { platform: state.application.platform } : undefined,
                });
            });
        }
    }

    return result;
};

export default lockerMiddleware;
